import commonService from './commonService'
import utils from './utils'
import axios from './axios'

const get = async (id, signal = null) => {
  const url = `${utils.url}/users/${id}`
  return await commonService.load(url, signal, null)
}

const getAll = async () => {
  const url = utils.url + '/users'
  const res = await axios.get(url)
  return res.data
}

const login = async (username, password) => {
  try {
    const url = utils.url + '/users/login'
    const credentials = { username, password }
    const res = await axios.post(url, credentials)
    return res.data
  } catch (error) {
    console.error(error)
  }
}

const verifyPassword = async (username, password) => {
  const url = utils.url + '/users/password/verify'
  const credentials = { username, password }
  const res = await axios.post(url, credentials)
  return res.data
}

const signUp = async (item) => {
  const url = utils.url + '/users/add'
  const res = await axios.post(url, item)
  return res.data
}

const getAllByOrganeFromSo = async (
  organeTypeId,
  organeId,
  offset = 0,
  limit = 10,
  signal = null,
) => {
  const url = `${utils.url}/users/fromso/${offset}-${limit}/${organeTypeId}/${organeId}`
  return await commonService.load(url, signal, [])
}

const countByOrgane = async (organeTypeId, organeId, signal = null) => {
  const url = `${utils.url}/users/count/${organeTypeId}/${organeId}`
  return await commonService.load(url, signal, 0)
}

const emailExists = async (email, signal = null) => {
  const url = `${utils.url}/users/check/email/${email}`
  return await commonService.load(url, signal, null)
}

const usernameExists = async (username, signal = null) => {
  const url = `${utils.url}/users/check/username/${username}`
  return await commonService.load(url, signal, null)
}

const add = async (instance, signal = null) => {
  return await commonService.add('users', instance, signal)
}

const update = async (instance, signal = null) => {
  return await commonService.update('users', instance, signal)
}

const lock = async (instance, signal = null) => {
  const url = `${utils.url}/users/lock`
  return await commonService.put(url, instance, signal)
}

const unlock = async (instance, signal = null) => {
  const url = `${utils.url}/users/unlock`
  return await commonService.put(url, instance, signal)
}

const setPassword = async (instance, signal = null) => {
  const url = `${utils.url}/users/password/set`
  return await commonService.put(url, instance, signal)
}

const reinitPassword = async (instance, signal = null) => {
  const url = `${utils.url}/users/password/reinit`
  return await commonService.put(url, instance, signal)
}

const delete_ = async (instance, signal = null) => {
  return await commonService.delete_('users', instance.id, signal)
}

export default {
  getAll,
  get,
  add,
  update,
  delete_,
  lock,
  unlock,
  login,
  signUp,
  getAllByOrganeFromSo,
  countByOrgane,
  emailExists,
  usernameExists,
  setPassword,
  reinitPassword,
  verifyPassword,
}
